import { API_REQUEST, GET_VIEW_PROPERTY_DETAILS, SET_VIEW_PROPERTY_DETAILS, RESET_VIEW_PROPERTY_DETAILS } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction } from "../../types";

// Get view property details action
export const getViewPropertyDetails = (user_id: string, roll: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/propdetails/get/${user_id}/${roll}`,
        next: GET_VIEW_PROPERTY_DETAILS,
        method: 'GET',
        authorization: true
    }
});

export const setViewPropertyDetails = (viewPropertyDetails: {}): AppNoApiAction => ({
    type: SET_VIEW_PROPERTY_DETAILS,
    payload: viewPropertyDetails
});

export const resetCurrentPropertyDetails = (): AppNoApiAction => ({
    type: RESET_VIEW_PROPERTY_DETAILS
});